import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let ViewSummaryDialogComponent = {
    selector: "vcViewSummaryDialog",
    templateUrl:
        "/angular/components/signature/view-summary-dialog.component.html",
    bindings: {
        summary: "=?",
        signature: "=?",
    },
    controller: class ViewSummaryDialogController {
        // * bindings for typescript compiler *
        public summary?: any;
        public signature?: any;
        // ************************************

        public dialog: DialogUtils;
        public $scope: any;
        public $sce: any;
        public showSignature;

        constructor(
            $scope: any,
            $sce: any,
            DialogUtils: DialogUtils,
            __app_type: string
        ) {
            this.dialog = DialogUtils;
            this.$scope = $scope;
            this.$sce = $sce;
            this.showSignature = false;
        }

        $onInit() {
            setTimeout(() => (this.showSignature = true), 500);
            this.summary = JSON.parse(this.summary);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("signature")
    .component(ViewSummaryDialogComponent.selector, ViewSummaryDialogComponent);
